import Base from './base'

export default class Messages extends Base {
  sendMessage(params: { subject: string; message: string; recipientEmail?: string }) {
    return this.apiClient.post('messages/send-message', params)
  }
}
